'use client';

import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import './globals.css';
import './styles/dark-mode.css';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { AuthProvider } from './providers/AuthProvider';
import { DarkModeProvider } from './contexts/DarkModeContext';
import { initializeSentry } from './sentry';
import { store } from './store/store';
import { Toaster } from './components/ui/toaster';
import { App } from './App';
import reportWebVitals from './reportWebVitals';

initializeSentry();

const container = document.getElementById('root')!;
const root = createRoot(container);

// Uncomment to initialize Mock Service Worker for API mocking in development
// enableMocking();

root.render(
  <Provider store={store}>
    <DarkModeProvider>
      <AuthProvider>
        <BrowserRouter>
          <App />
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </DarkModeProvider>
  </Provider>
);

reportWebVitals();
